import React from "react";

// Need SVG icons for dynamic fill when toggling dark mode
export const IconShieldCheck = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2_9937)">
        <path
          d="M22.7783 4.08706L13.4033 0.180811C13.1165 0.0587402 12.8096 0 12.5029 0C12.1963 0 11.8896 0.0583984 11.6016 0.180469L2.22705 4.08706C1.354 4.44692 0.78125 5.30239 0.78125 6.20571C0.78125 18.818 10.0293 24.9997 12.4951 24.9997C14.9023 24.9997 24.2188 18.9108 24.2188 6.20571C24.2188 5.30239 23.6475 4.44692 22.7783 4.08706ZM12.5 22.6559C7.73926 20.6735 3.125 14.5163 3.125 6.24966L12.5 2.34341L21.875 6.24966C21.875 14.736 17.0703 20.7516 12.5 22.6559ZM9.77051 12.0602C9.58496 11.8307 9.28223 11.6745 8.98438 11.6745C8.31494 11.6745 7.8125 12.2218 7.8125 12.8463C7.8125 13.1881 7.9248 13.4909 8.1543 13.6764L10.498 16.0202C10.7178 16.2838 11.0205 16.362 11.3281 16.362C11.4548 16.362 11.8877 16.3377 12.2178 15.953L16.9053 10.4843C17.0948 10.2632 17.1875 9.9916 17.1875 9.72158C17.1875 9.36001 16.9048 8.5502 16.0167 8.5502C15.6868 8.5502 15.3584 8.68843 15.126 8.9585L11.2646 13.5104L9.77051 12.0602Z"
          fill="#476175"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_9937">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconCertificate = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2_9941)">
        <path
          d="M12.0802 16.5186C12.4464 16.1523 12.5865 15.6152 12.4525 15.1147C12.19 14.1079 12.1839 14.2481 12.4525 13.2407C12.5867 12.7339 12.4464 12.1968 12.0802 11.8306C11.3526 11.0889 11.3819 11.2109 11.1573 10.2051C11.0304 9.70704 10.6007 9.31641 10.1515 9.17969C9.15538 8.90625 9.27745 8.9795 8.54991 8.24219C8.19346 7.87598 7.62217 7.7295 7.17296 7.86133C6.17833 8.12989 6.31895 8.12989 5.33018 7.86133C4.83458 7.7295 4.30968 7.87598 3.94981 8.24219C3.21739 8.9795 3.33946 8.90625 2.35069 9.17969C1.85655 9.31641 1.47618 9.70704 1.3419 10.2051C1.07945 11.2183 1.14659 11.0898 0.420515 11.8286C0.0604078 12.1948 -0.0838793 12.7319 0.0503004 13.2388C0.312752 14.2456 0.312752 14.1055 0.0503004 15.1128C-0.083977 15.6133 0.0604078 16.1504 0.420515 16.5166C1.14659 17.2549 1.07969 17.1328 1.3419 18.1401C1.47618 18.647 1.85655 19.0376 2.35118 19.1714C3.05284 19.3606 2.9127 19.3179 3.12608 19.4155V25L6.25059 23.4375L9.3751 25V19.4141C9.58262 19.3164 9.4483 19.3591 10.15 19.1699C10.6382 19.0356 10.985 18.645 11.1568 18.1387C11.3819 17.1289 11.3526 17.2559 12.0802 16.5186ZM6.2501 17.1875C4.52305 17.1875 3.12559 15.79 3.12559 14.0625C3.12559 12.335 4.52354 10.9375 6.2501 10.9375C7.97667 10.9375 9.37462 12.335 9.37462 14.0625C9.37462 15.79 7.97862 17.1875 6.2501 17.1875ZM24.087 4.55958L20.443 0.915044C19.8536 0.329204 19.0577 4.88281e-06 18.2325 4.88281e-06L9.33116 0C7.60509 0 6.20616 1.39893 6.20616 3.125L6.20667 6.49121C6.20667 6.49121 7.28187 5.96875 8.55042 6.4544L8.59385 3.13135C8.59385 2.69991 8.94366 2.3501 9.3751 2.3501H17.1876V6.25001C17.1876 7.1128 17.8873 7.81251 18.7501 7.81251H22.6124V21.875C22.6124 22.3064 22.2626 22.6563 21.8312 22.6563H10.9376L10.8937 25L21.8312 25C23.5499 25 24.9562 23.5938 24.9562 21.875V6.76758C25.0001 5.94239 24.673 5.14649 24.087 4.55958Z"
          fill="#476175"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_9941">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
